<template>
  <v-container>
    <v-row v-if="loading">
      <v-col rows="12">
        <p style="width: 100%; text-align: center;">
          <v-icon>fas fa-spinner fa-spin</v-icon> Carregando ...
        </p>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card class="my-4">
          <v-card-title>
            Integrações
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchIntegrations"
              append-icon="fas fa-search"
              label="Pesquisa"
              single-line
              clearable
              hide-details
            ></v-text-field>
            <v-btn
              color="primary"
              class="ml-5"
              icon
              @click="dialogs.newIntegration = true"
              ><v-icon>fas fa-plus</v-icon></v-btn
            >
          </v-card-title>
          <v-data-table
            style="cursor: pointer;"
            :headers="tableIntegrations.headers"
            :items="integrations"
            item-key="id"
            class="elevation-1"
            @click:row="showDialogEditIntegration"
            :search="searchIntegrations"
          ></v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogs.editIntegration"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogs.editIntegration = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Editar integração</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="setIntegration()">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <v-row v-if="editIntegration && editIntegration.stores">
            <v-col cols="6">
              <v-text-field
                v-model="editIntegration.name"
                label="Nome"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editIntegration.domain"
                label="Domínio"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editIntegration.key"
                label="Parametro da URL/key"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editIntegration.type"
                :items="integrationType"
                item-value="id"
                item-text="text"
                label="Tipo de integração"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <v-card class="my-4">
                <v-card-title>
                  Lojas cadastradas
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchStores"
                    append-icon="fas fa-search"
                    label="Pesquisa"
                    single-line
                    clearable
                    hide-details
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="ml-5"
                    icon
                    @click="dialogs.newStore = true"
                    ><v-icon>fas fa-plus</v-icon></v-btn
                  >
                </v-card-title>
                <v-data-table
                  style="cursor: pointer;"
                  :headers="tableStores.headers"
                  :items="editIntegration.stores"
                  item-key="id"
                  class="elevation-1"
                  @click:row="showDialogEditStore"
                  :search="searchStores"
                ></v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.newIntegration" max-width="800">
      <v-card>
        <v-card-title class="headline">Nova integração</v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="newIntegration.name"
                label="Nome (nome da integração)"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="newIntegration.domain"
                label="Domínio (url de geração do deeplink)"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="newIntegration.key"
                label="URL/key (parametro da url para inserir a url)"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="newIntegration.type"
                :items="integrationType"
                item-value="id"
                item-text="text"
                label="Tipo de integração"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="dialogs.newIntegration = false"
          >
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="createNewIntegration()">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.newStore" max-width="800">
      <v-card>
        <v-card-title class="headline">Nova loja</v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="newStore.name"
                label="Nome (nome da integração)"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newStore.domain"
                label="Domínio (url de geração do deeplink)"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newStore.key"
                label="Parametro"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="newStore.value"
                label="Valor do campo"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogs.newStore = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="createNewStore()">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.editStore" max-width="800">
      <v-card>
        <v-card-title class="headline">Nova loja</v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="editStore.name"
                label="Nome (nome da integração)"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editStore.domain"
                label="Domínio (url de geração do deeplink)"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editStore.key"
                label="Parametro"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="editStore.value"
                label="Valor do campo"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="removeStore()">
            REMOVER LOJA
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogs.editStore = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="setStore()">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {},
  data() {
    return {
      stores: [],
      loading: false,
      integrations: [],
      tableIntegrations: {
        headers: [
          { text: 'Nome', value: 'name' },
          { text: 'Domínio', value: 'domain' },
          { text: 'URL/key', value: 'key' },
          { text: 'Tipo', value: 'type' }
        ]
      },
      tableStores: {
        headers: [
          { text: 'Nome', value: 'name' },
          { text: 'Domínio', value: 'domain' },
          { text: 'key', value: 'key' },
          { text: 'Valor', value: 'value' }
        ]
      },
      integrationType: [
        { id: 0, text: 'Criação de deeplink padrão' },
        { id: 1, text: 'Criação de deeplink 2 passos (via api)' }
      ],
      dialogs: {
        new: false,
        newIntegration: false,
        editIntegration: false,
        newStore: false,
        editStore: false
      },
      searchIntegrations: '',
      searchStores: '',
      newIntegration: {},
      newStore: {},
      editIntegration: {},
      editStore: {}
    }
  },
  methods: {
    fetchIntegrationStores() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `integration/store/list`)
          .then(result => {
            console.debug(result)
            if (result && result.data) {
              vm.stores = result.data
            }
            resolve(result)
          })
          .catch(error => {
            console.debug(error)
            if (error && error.message) {
              vm.$snotify.error(error.message)
            }
            reject(error)
          })
      })
    },
    fetchIntegrations() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `integration/list`)
          .then(result => {
            console.debug(result)
            if (result && result.data) {
              vm.integrations = result.data
            }
            resolve(result)
          })
          .catch(error => {
            console.debug(error)
            if (error && error.message) {
              vm.$snotify.error(error.message)
            }
            reject(error)
          })
      })
    },
    showDialogEditIntegration(_i) {
      var vm = this
      vm.editIntegration = _i
      vm.editIntegration.stores = []
      if (vm.stores && vm.stores.length > 0) {
        vm.stores.forEach(store => {
          if (store.integration_id == _i.id) {
            vm.editIntegration.stores.push(store)
          }
        })
      }
      vm.dialogs.editIntegration = true
    },
    showDialogEditStore(_s) {
      var vm = this
      vm.editStore = _s
      vm.dialogs.editStore = true
    },
    generateIntegrations() {
      var vm = this
      let result = []
      if (vm.integrations && vm.integrations.length > 0) {
        vm.integrations.forEach(integration => {
          let _i = integration
          _i.stores = []
          if (vm.stores && vm.stores.length > 0) {
            vm.stores.forEach(store => {
              if (store.integration_id === _i.id) {
                _i.stores.push(store)
              }
            })
          }
          result.push(_i)
        })
      }
      console.debug(result)
      return result
    },
    createNewIntegration() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('put', `integration/new`, vm.newIntegration)
          .then(result => {
            console.debug(result)
            if (result && result.data) {
              vm.integrations.push(result.data)
            }
            vm.newIntegration = {}
            vm.dialogs.newIntegration = false
            vm.$snotify.success('Nova interação criada com sucesso')
            resolve(result)
          })
          .catch(error => {
            console.debug(error)
            if (error && error.message) {
              vm.$snotify.error(error.message)
            }
            reject(error)
          })
      })
    },
    setIntegration() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('put', `integration/edit`, vm.editIntegration)
          .then(result => {
            console.debug(result)
            vm.editIntegration = {}
            vm.dialogs.editIntegration = false
            vm.$snotify.success('Integração editada com sucesso')
            resolve(result)
          })
          .catch(error => {
            console.debug(error)
            if (error && error.message) {
              vm.$snotify.error(error.message)
            }
            reject(error)
          })
      })
    },
    setStore() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('put', `integration/store/edit`, vm.editStore)
          .then(result => {
            console.debug(result)
            vm.editStore = {}
            vm.dialogs.editStore = false
            vm.showDialogEditIntegration(vm.editIntegration)
            vm.$snotify.success('Loja editada com sucesso')
            resolve(result)
          })
          .catch(error => {
            console.debug(error)
            if (error && error.message) {
              vm.$snotify.error(error.message)
            }
            reject(error)
          })
      })
    },
    createNewStore() {
      var vm = this
      vm.newStore.integration_id = vm.editIntegration.id
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('put', `integration/store/new`, vm.newStore)
          .then(result => {
            console.debug(result)
            if (result && result.data) {
              vm.stores.push(result.data)
            }
            vm.newStore = {}
            vm.dialogs.newStore = false
            vm.showDialogEditIntegration(vm.editIntegration)
            vm.$snotify.success('Nova loja criada com sucesso')
            resolve(result)
          })
          .catch(error => {
            console.debug(error)
            if (error && error.message) {
              vm.$snotify.error(error.message)
            }
            reject(error)
          })
      })
    },
    removeStore() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('delete', `integration/store/delete`, vm.editStore)
          .then(result => {
            console.debug(result)
            let _ixDelete = null
            for (let ixSt = 0; ixSt < vm.stores.length; ixSt++) {
              const store = vm.stores[ixSt]
              if (store.id == vm.editStore.id) {
                _ixDelete = ixSt
                break
              }
            }
            vm.stores.splice(_ixDelete, 1)
            vm.editStore = {}
            vm.dialogs.editStore = false
            vm.showDialogEditIntegration(vm.editIntegration)
            vm.$snotify.success('Loja removida com sucesso')
            resolve(result)
          })
          .catch(error => {
            console.debug(error)
            if (error && error.message) {
              vm.$snotify.error(error.message)
            }
            reject(error)
          })
      })
    }
  },
  created() {
    var vm = this
    vm.loading = true
    vm.fetchIntegrations()
      .then(() => {
        vm.fetchIntegrationStores()
          .then(() => {
            vm.loading = false
          })
          .catch(error => {
            vm.loading = false
            vm.$snotify.error(
              'Network error. Try again later: ' + error.message
            )
          })
      })
      .catch(error => {
        vm.loading = false
        vm.$snotify.error('Network error. Try again later: ' + error.message)
      })
  },
  mounted() {},
  computed: {}
}
</script>
